const FacebookIcon = () => (
  <img
    className="img--footer_social_icon"
    src={`/svg/facebook.svg`}
    alt="facebook"
  />
);

export default FacebookIcon;
